"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Capacity {
    constructor(tokenService, userRepository, capacityRepository) {
        this.getCapacity = async () => {
            const token = await this.tokenService.getValidToken();
            const user = await this.userRepository.getUserByToken(token);
            return this.capacityRepository.getCapacityByUserId(user.id);
        };
        this.setCapacity = async (capacity) => {
            const token = await this.tokenService.getValidToken();
            const user = await this.userRepository.getUserByToken(token);
            const capacities = await this.capacityRepository.getCapacityByUserId(user.id);
            capacities.forEach((capacityItem) => {
                capacityItem.original.maximum = capacity.original.maximum;
                capacityItem.premium.maximum = capacity.premium.maximum;
            });
            await this.capacityRepository.setCapacityByUserId(user.id, capacities);
        };
        this.tokenService = tokenService;
        this.userRepository = userRepository;
        this.capacityRepository = capacityRepository;
    }
}
exports.default = Capacity;
//# sourceMappingURL=Capacity.js.map